import { APP_ID, ACR_METADATA_KEY, PLAYBACK_KEY } from 'config';
import { noop } from 'lodash';
import { PORTAL } from 'routes/portal';
import { stationData } from './station_data';

const axios = require('axios');
export const ApiConsumer = axios.create();
export const ACRConsumer = axios.create({
  baseURL: 'https://eu-api-v2.acrcloud.com/api/external-metadata',
  headers: { Authorization: 'Bearer ' + ACR_METADATA_KEY },
});

export const Backend = axios.create({
  baseURL: '/api',
});

const publicPaths = [PORTAL.LOGIN, PORTAL.FORGOT_PASSWORD, PORTAL.REGISTER];

Backend.interceptors.request.use(
  (request) => {
    const insidePrivatePath = !publicPaths.includes(window.location.pathname);
    if (isAuthenticated() && insidePrivatePath) {
      request.headers.Authorization = `Api-Key ${
        JSON.parse(localStorage.getItem(APP_ID))?.token
      }`;
    } else if (insidePrivatePath) {
      window.location.replace(PORTAL.LOGIN);
    }

    return request;
  },
  (error) => {
    return Promise.reject(error);
  },
);

Backend.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && (error.response.statusText === 'Unauthorized' && error.response.status === 401)) {
      window.location.replace(PORTAL.LOGIN);
    }
    return Promise.reject(error);
  },
);



export function getBroadcastRecording(
  projectId,
  streamId,
  timestamp,
  duration,
) {
  const BroadcastRecordingConsumer = axios.create({
    baseURL: `https://api-v2.acrcloud.com/api/bm-cs-projects/${projectId}/streams/${streamId}/recordings?timestamp_utc=${timestamp}&played_duration=${duration}&record_before=1&record_after=1`,
    headers: { Authorization: 'Bearer ' + PLAYBACK_KEY },
    'Content-Type': 'audio/mpeg',
    'Content-Disposition': 'filename=recording.mp3',
    responseType: 'blob',
  });

  return BroadcastRecordingConsumer.get('/recordings');
}

export const isAuthenticated = () => {
  return !!localStorage.getItem(APP_ID);
};

ApiConsumer.interceptors.request.use(
  (request) => {
    if (isAuthenticated())
      request.headers.Authorization = `Api-Key ${
        JSON.parse(localStorage.getItem(APP_ID))?.token
      }`;
    else window.location.replace(PORTAL.LOGIN);
    return request;
  },
  (error) => {
    return Promise.reject(error);
  },
);

ApiConsumer.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && (error.response.statusText === 'Unauthorized' && error.response.status === 401)) {
      window.location.replace(PORTAL.LOGIN);
    }
    return Promise.reject(error);
  },
);

export const retrieveRecording = (
  item,
  cb = noop,
  errCb = (err) => console.log('broadcast recording error', err),
  finalCb = noop,
) => {
  item.broadcast_stream = {
    ...item.broadcast_stream,
    ...stationData[item?.broadcast_stream?.id || item.broadcast_stream_id],
  };
  getBroadcastRecording(
    item.broadcast_stream.project_id,
    item.broadcast_stream.key,
    item.record_timestamp,
    item.duration,
  )
    .then((res) => {
      let track = {
        music: {
          id: item.id,
          file: URL.createObjectURL(res.data),
          autoStart: true,
        },
      };

      cb(track);
    })
    .catch(errCb)
    .finally(finalCb);
};
